import { fadeIn as fadeInOriginal } from '@pernod-ricard-global-cms/jsanimations';

/**
 * Loading time for lazy load. Change here to apply it globally.
 * @type {number}
 */
const loadingTime = 100;

/**
 * Wrapper for fadeIn() function from '@pernod-ricard-global-cms/jsanimations', using a different timing
 * @param element
 * @param time
 * @param opacity
 * @returns {*}
 */
export function fadeIn(element, time = loadingTime, opacity = 1) {
  return fadeInOriginal(element, time, opacity);
}

const api = {
  fadeIn
};

export default api;
